export default {
  DEFAULT: 'defaultMode',
  VOUCHER: 'voucherMode',
  TABLE_DELIVERY: 'tableDeliveryMode',
  CUBBY_MANAGER: 'cubbyManager',
  GPS_LOCATION: 'gpsLocationDeliveryMode',
  ORDER_STATUS_MANAGER: 'orderStatusManager',
};
